<template>
    <main class="L_HomePageHolder">
        <TSTHeader @SetSelectedComp="(SelectedComp) => this.SetSelectedComp(SelectedComp)" :BasketCount="BasketCount"/>
        <TSTHome v-if="SelectedComp=='Home'"/>
        <TSTShop v-if="SelectedComp=='Shop'" @SetSelectedComp="(SelectedComp, ExtraItems) => this.SetSelectedComp(SelectedComp, ExtraItems)"/>
        <TSTShopCategory v-if="SelectedComp=='Shop Category'" :ShopItems="ExtraItems" @SetSelectedComp="(SelectedComp) => this.SetSelectedComp(SelectedComp)" @UpdateBasket="UpdateBasket"/>
        <TSTContactUs v-if="SelectedComp=='Contact Us'" @SetSelectedComp="(SelectedComp) => this.SetSelectedComp(SelectedComp)"/>
        <TSTBasket v-if="SelectedComp=='Basket'" @UpdateBasket="UpdateBasket" @SetSelectedComp="(SelectedComp, BasketItems, OrderNumber, ClientDetails) => this.SetSelectedComp(SelectedComp, BasketItems, OrderNumber, ClientDetails)"/>
        <TSTOrderSuccessful v-if="SelectedComp=='Order Successful'" @SetSelectedComp="(SelectedComp) => this.SetSelectedComp(SelectedComp)" :BasketItems="ExtraItems" :OrderNumber="OrderNumber" @UpdateBasket="UpdateBasket" :ClientDetails="ClientDetails"/>
        <TSTFooter @SetSelectedComp="(SelectedComp) => this.SetSelectedComp(SelectedComp)"/>
        <div @click="OpenWhatsapp()" class="WhatsappFloat"><i class="fa WhatsappIcon">&#xf232;</i></div>
    </main>
</template>

<script>

import TSTHeader from '../widgets/TSTHeader.vue'
import TSTHome from '../main/navigation/TSTHome.vue'
import TSTFooter from '../widgets/TSTFooter.vue'
import TSTShop from '../main/navigation/TSTShop.vue'
import TSTShopCategory from '../main/navigation/shop/TSTShopCategory.vue'
import TSTContactUs from '../main/navigation/TSTContactUs.vue'
import TSTBasket from '../main/navigation/TSTBasket.vue'
import TSTOrderSuccessful from '../main/navigation/TSTOrderSuccessful.vue'

export default{
  name:'App',
  components: 
  {
    TSTHeader,
    TSTHome,
    TSTFooter,
    TSTShop,
    TSTShopCategory,
    TSTContactUs,
    TSTBasket,
    TSTOrderSuccessful
},
  data(){
    return{
      SelectedComp: 'Home',
      ExtraItems: '',
      OrderNumber: '',
      BasketCount: 0,
      ClientDetails: ''
    }
  },
  created()
  {
    if(!window.location.hash) this.SetSelectedComp("Home");
    window.addEventListener( "hashchange", (event)=> { this.ProcessLocationHash()})
    this.ProcessLocationHash()
   
    var BasketItems = window.localStorage.getItem("BasketItems")
    if(BasketItems)
    {
      if(BasketItems.length > 0 && BasketItems != "undefined") this.UpdateBasket(JSON.parse(BasketItems))
    }
  },
  methods:
  {
    SetSelectedComp(SelectedComp, ExtraItems, OrderNumber, ClientDetails)
    {
      this.SelectedComp = SelectedComp
      this.ExtraItems = ExtraItems
      this.OrderNumber = OrderNumber
      this.ClientDetails = ClientDetails

      window.location.hash = this.EncodeQueryString({_comp:SelectedComp})
    },
    OpenWhatsapp()
		{
			window.open("https://wa.me/270663421732")
		},
    UpdateBasket(BasketItems)
    {
        BasketItems = JSON.parse(JSON.stringify(BasketItems))
        var i = 0
        for(var BasketItem in BasketItems) i++
       
        this.BasketCount = i
    },
		async ProcessLocationHash() 
		{
			if(window.location.hash)
			{
        console.log(window.location.hash)
				var Query = this.DecodeQueryString(window.location.hash.substr(1));

				if(Query._comp)
				{
					this.SelectedComp = Query._comp;
				}
			}
		},
		DecodeQueryString(Query) 
		{
			var FirstChar = Query.substring(0,1)
			if(FirstChar=="?" || FirstChar=="#") Query = Query.substring(1)

			var Result = {};
			var Pairs = Query.split("&")
			for(var i in Pairs)
			{
				var Pair = Pairs[i].split("=")
				Result[decodeURIComponent(Pair[0])] = decodeURIComponent(Pair[1])
			}

			if(Result[""]) delete(Result[""])
	
			return Result
		},
		EncodeQueryString(Data)
		{
			var Str = ""
			if(Data)
			{
				for(var i in Data)
				{
					if(typeof(Data[i])!='object')
					{
						Str += (Str ? "&" : "")
						Str += decodeURIComponent(i) + "=" + decodeURIComponent(Data[i])
					}
				}
			}
			return Str
		}
  }
}

</script>

<style lang="scss">

@import "../../assets/GlobalCss.scss";

.WhatsappFloat 
{
	position: fixed;
	width: 80px;
	height: 80px;
	bottom: 60px;
	right: 60px;
	background-color: #25d366;
	color: #fff;
	border-radius: 50px;
	text-align: center;
	font-size: 50px;
	box-shadow: 2px 2px 3px #999;
	z-index: 100;

  @include mobile()
  {
    width: 60px;
	  height: 60px;
    right: 20px;
    bottom: 20px;
    font-size: 40px;
  }
}

.WhatsappIcon 
{
  margin-top: 16px;
  
  @include mobile()
  {
    margin-top: 1rem;
  }
}

</style>